import { capitalize } from "./common";

// USED
export const getInstallmentsLabels = (
  paymentMethod,
  paymentPeriod = 12,
  alternativeLabel = "Application",
  autoPayAlternativeLabel = null,
) => {
  alternativeLabel = alternativeLabel
    .split(" ")
    .map((t) => capitalize(t))
    .join(" ");
  const installmentLabels = {
    switchLabel: `1st ${alternativeLabel}`,
    emailLabel: `${autoPayAlternativeLabel} Pricing`,
    note: "",
  };

  if (paymentMethod === "monthly-payment") {
    installmentLabels.switchLabel = "per Month";
    installmentLabels.emailLabel = "Monthly Billing";
    installmentLabels.note = `* cost is spread across ${paymentPeriod} months`;

    if (paymentPeriod < 12) {
      installmentLabels.emailLabel = "Budget Billing";
    }
  }

  if (
    autoPayAlternativeLabel &&
    autoPayAlternativeLabel !== "Auto-Pay" &&
    paymentMethod !== "monthly-payment"
  ) {
    installmentLabels.emailLabel = `${autoPayAlternativeLabel} Pricing`;
  }
  return installmentLabels;
};

export const getInstallmentPricing = (
  totalCost,
  paymentMethod,
  paymentPeriod,
) => {
  if (paymentMethod === "monthly-payment") {
    return Number.parseFloat((totalCost / paymentPeriod).toFixed(2));
  } else {
    throw new Error("not monthly pricing");
  }
};
